export const START_FETCH_COMPANIES = 'START_FETCH_COMPANIES'
export const GET_ALL_COMPANIES_LIST = 'GET_ALL_COMPANIES_LIST';
export const FINISH_FETCH_COMPANIES = 'FINISH_FETCH_COMPANIES';

export const START_FETCH_PERSONS = 'START_FETCH_PERSONS'
export const GET_ALL_PERSONS_LIST = 'GET_ALL_PERSONS_LIST';
export const FINISH_FETCH_PERSONS = 'FINISH_FETCH_PERSONS';

export const START_FETCH_REGIONS = 'START_FETCH_REGIONS'
export const GET_ALL_REGIONS_LIST = 'GET_ALL_REGIONS_LIST';
export const FINISH_FETCH_REGIONS = 'FINISH_FETCH_REGIONS';

export const START_FETCH_SOURCES = 'START_FETCH_SOURCES'
export const GET_ALL_SOURCES_LIST = 'GET_ALL_SOURCES_LIST';
export const FINISH_FETCH_SOURCES = 'FINISH_FETCH_SOURCES';

export const START_FETCH_LAWS_SOURCES = 'START_FETCH_LAWS_SOURCES'
export const GET_ALL_LAWS_SOURCES_LIST = 'GET_ALL_LAWS_SOURCES_LIST';
export const FINISH_FETCH_LAWS_SOURCES = 'FINISH_FETCH_LAWS_SOURCES';



// WEBPACK FOOTER //
// ./src/redux_related/additional/actions.js